import { Grid } from '@material-ui/core';
import * as React from 'react';

import { Zoom } from '../Zoom';

import './index.scss';

interface IProps {
    content: string[];
    setSelectedSrc: (src: string) => void;
}

export const TripleMedia: React.FC<IProps> = (
    { content, setSelectedSrc }
) => (
    <div className="tripleMedia">
        <Grid container spacing={2}>
            {content.map((src, i) => (
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={4}
                    key={i}
                    className="tripleMedia__item"
                >
                    <Zoom onClick={() => setSelectedSrc(src)} />
                    <img src={src} alt="" />
                </Grid>
            ))}
        </Grid>
    </div>
);
